import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: false,
})
export class NavbarComponent {
  @Input() showSignOut = false;

  // Emit event to parent
  @Output() logout = new EventEmitter<void>();
  @Output() login = new EventEmitter<void>();

  performLogout(): void {
    this.logout.emit(); // Emit to parent
  }

  performOktaLogin(): void {
    this.login.emit(); // Emit to parent
  }
}
